var _g, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNeedHelpSubhead(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 517.66 98.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m0,22.39h13.1l.63,7.08c3.49-5.39,8.87-8.34,15.53-8.34,12.57,0,19.75,7.39,19.65,24.19v29.89h-13.94v-27.04c0-10.67-3.91-13.84-9.82-13.94-7.29-.11-11.2,4.54-11.2,13.31v27.67H0V22.39Z",
    fill: "#2c3037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.15,48.8c0-16.27,11.41-27.67,27.46-27.67,13.84,0,25.77,11.3,25.77,31.37h-38.66c.63,7.18,6.87,11.51,13.63,11.51,5.81,0,9.29-2.75,11.3-6.65l12.46,4.86c-4.54,8.98-12.78,14.26-25.24,14.26-15.63,0-26.72-11.41-26.72-27.67Zm15.32-6.65h22.81c-.63-6.65-6.55-9.19-11.09-9.19s-10.98,2.53-11.72,9.19Z",
    fill: "#2c3037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.66,48.8c0-16.27,11.41-27.67,27.46-27.67,13.84,0,25.77,11.3,25.77,31.37h-38.66c.63,7.18,6.87,11.51,13.63,11.51,5.81,0,9.29-2.75,11.3-6.65l12.46,4.86c-4.54,8.98-12.78,14.26-25.24,14.26-15.63,0-26.72-11.41-26.72-27.67Zm15.32-6.65h22.81c-.63-6.65-6.55-9.19-11.09-9.19s-10.98,2.53-11.72,9.19Z",
    fill: "#2c3037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174.18,48.8c0-16.9,9.29-27.67,23.87-27.67,6.97,0,12.36,2.96,15.84,8.34V1.27h13.94v73.93h-13.2l-.53-7.29c-3.49,5.49-8.98,8.56-16.05,8.56-14.58,0-23.87-10.77-23.87-27.67Zm39.71,1.58v-3.17c-.63-7.92-5.49-13.2-12.36-13.2-7.5,0-12.89,6.13-12.89,14.79s5.49,14.89,12.99,14.89c6.76,0,11.62-5.39,12.25-13.31Z",
    fill: "#2c3037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m265.12,1.27h13.94v27.88c3.49-5.28,8.77-8.03,15.32-8.03,12.57,0,19.75,7.39,19.75,24.19v29.89h-13.94v-27.04c0-10.67-4.01-13.84-9.93-13.94-7.18-.11-11.2,4.54-11.2,13.31v27.67h-13.94V1.27Z",
    fill: "#2c3037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m322.36,48.8c0-16.27,11.41-27.67,27.46-27.67,13.84,0,25.77,11.3,25.77,31.37h-38.66c.63,7.18,6.87,11.51,13.62,11.51,5.81,0,9.29-2.75,11.3-6.65l12.46,4.86c-4.54,8.98-12.78,14.26-25.24,14.26-15.63,0-26.72-11.41-26.72-27.67Zm15.31-6.65h22.81c-.63-6.65-6.55-9.19-11.09-9.19s-10.99,2.53-11.72,9.19Z",
    fill: "#2c3037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m383.73,1.27h13.94v73.93h-13.94V1.27Z",
    fill: "#2c3037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m410.24,22.39h13.1l.63,7.39c3.49-5.49,8.98-8.66,16.16-8.66,14.58,0,23.87,10.77,23.87,27.67s-9.29,27.67-23.87,27.67c-7.08,0-12.46-3.06-15.95-8.45v28.31h-13.94V22.39Zm39.29,26.41c-.11-8.66-5.39-14.79-12.89-14.79s-12.46,6.13-12.46,14.79,5.18,14.89,12.36,14.89,12.89-6.23,12.99-14.89Z",
    fill: "#2c3037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m483.86,35.38l7.82-.53c7.39-.42,12.57-4.22,12.57-11.51,0-6.23-4.86-10.77-11.83-10.77-4.96,0-8.77,2.75-10.14,6.44l-12.67-3.59c2.75-9.29,11.09-15.42,22.81-15.42,14.79,0,25.24,9.72,25.24,23.34,0,11.41-7.92,19.22-19.75,20.7l-.21,9.93h-13.31l-.53-18.59Zm-1.27,32.85c0-4.65,3.7-8.45,8.45-8.45s8.45,3.8,8.45,8.45-3.8,8.55-8.45,8.55-8.45-3.8-8.45-8.55Z",
    fill: "#2c3037"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 87.13,
    width: 399.23,
    height: 11.01,
    fill: "#35c0e2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 435.18,
    y: 87.13,
    width: 81.72,
    height: 11.01,
    fill: "#35c0e2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeedHelpSubhead);
export default __webpack_public_path__ + "static/media/need-help-subhead.73ecc2ddf46a36d1acddacc5b663c9f0.svg";
export { ForwardRef as ReactComponent };